<div class="">
  <div class="modal-header">
    <!-- <ng-container *ngIf="this.update==undefined">
    <h4 class="modal-title kx-modal-heading pl-2">
      <strong>Admission Successful</strong>
    </h4>
  </ng-container> -->
  <!-- <ng-container *ngIf="this.update!=undefined">
  <h4 class="modal-title kx-modal-heading pl-2">
    <strong>Updated Successfully</strong>
  </h4>
</ng-container> -->
<span class="kx-modal-close" (click)="hide();"><i class="fa fa-close"></i></span>
</div>
<div class="modal-body">
  <ng-container>
    @if (this.update==undefined) {
      <div>
        <p>Admission Done ! Your Admission Id is {{data.resource[0].encounter_id}}</p>
      </div>
    }
    @if (this.update!=undefined) {
      <div>
        <p>Your Admission Id is {{data.resource[0].encounter_id}}</p>
      </div>
    }
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="secondary-btn" data-dismiss="modal" (click)="hide()">
    <span>Back to List</span>
    <i class="fa fa-arrow-left" aria-hidden="true"></i>
  </button>
  <button type="button" class="primary-btn" (click)="printFacesheet()">
    <span>Print FaceSheet</span>
    <i class="fa fa-print" aria-hidden="true"></i>
  </button>
  <button type="button" class="primary-btn" (click)="printLabel()">
    <span>Print Label</span>
    <i class="fa fa-print" aria-hidden="true"></i>
  </button>
  <button type="button" class="primary-btn" (click)="printAdmissionSlip()">
    <span>Print Admission Slip</span>
    <i class="fa fa-print" aria-hidden="true"></i>
  </button>
  <button type="button" class="primary-btn" (click)="printCaseSheetSticker()">
    <span>Case Sheet Sticker</span>
    <i class="fa fa-print" aria-hidden="true"></i>
  </button>
  <button type="button" class="primary-btn" (click)="printTestSticker()">
    <span>Test Sticker</span>
    <i class="fa fa-print" aria-hidden="true"></i>
  </button>
</div>
</div>